export default class FormModifier {
  constructor(host, activistCodeArray) {
    this.host = host;
    this.activistCodeArray = activistCodeArray;
  }

  _changePlaceholder = () => {
    const emailInputs = this.host.querySelectorAll("input[type='email']");

    emailInputs.forEach(item => { item.placeholder = ''; });
  };

  _checkedCheckboxes = () => {
    const checkboxes = this.host.querySelectorAll('.Interests .at-check');

    checkboxes.forEach(checkbox => {
      this.activistCodeArray.forEach(activistCode => {
        if (checkbox.querySelector('span').innerText === activistCode) {
          checkbox.querySelector('input').checked = true;
        }
      });
    });
  };

  _setTabIndexes = () => {
    this.host.querySelector('input[name="FirstName"]').setAttribute('tabIndex', '1');
    this.host.querySelector('input[name="LastName"]').setAttribute('tabIndex', '2');
    this.host.querySelector('input.intl-phone-MobilePhone').setAttribute('tabIndex', '3');
    this.host.querySelector('input[name="EmailAddress"]').setAttribute('tabIndex', '4');
    this.host.querySelector('input[name="PostalCode"]').setAttribute('tabIndex', '5');
    this.host.querySelector('select').setAttribute('tabIndex', '6');
  };

  populate = () => {
    this._changePlaceholder();
    this._checkedCheckboxes();
    setTimeout(this._setTabIndexes);
  };
}
